import { ANALYTICS } from '../config'
import { REGEX } from './consts'

/**
 * Tracking GA Events on any element
 * Use the following attributes on any clickable element
 * - [data-event-category]   - required
 * - [data-event-action] - optional, default: 'click'
 * - [data-event-label]  - optional, default: the value of the element's innerText property
 * Reference: https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 *
 * @param {MouseEvent} event - the click event
 */
const gaCustomEventClickHandler = function (event) {
  const element = event.target.closest('[data-event-position]')
  if (!element) return

  const eventPosition = element.dataset.eventPosition

  gtag('event', 'click', { 'position': eventPosition, 'link_url': event.target.href, 'link_text': event.target.innerText })
}

/**
 * Track link clicks as events if…
 * 1. They’re sketch:// links
 * 2. They’re http links that match our config
 * 3. They’re http links for non-sketch.com domains
 *
 * Note: we assume support of Beacon API, which ensures event is tracked even after browser changes to destination url
 * @param {MouseEvent} event - the click event
 */
const gaLinkClickHandler = function (event) {
  /** @type {HTMLAnchorElement} */
  const link = event.target.closest('a[href]')

  // Must be a click on a link, and not a same-page anchor link
  if (!link || link.getAttribute('href').match(REGEX.anchorHref)) return

  const eventData = { eventCategory: null, eventAction: 'click', eventLabel: link.href }

  if (link.protocol === 'sketch:') {
    eventData.eventCategory = 'download-sketch-protocol'
  } else if (link.protocol.match(/^https?:$/) && link.host) {
    const hostGroup = ANALYTICS.LINKS.find(({ hostnames }) => hostnames.includes(link.host))
    if (hostGroup) {
      // ignore trailing slash on link's path
      const linkPath = link.pathname.replace(/\/$/, '')
      // eslint-disable-next-line no-restricted-syntax
      for (const [category, paths] of Object.entries(hostGroup.categories)) {
        if (paths.find((path) => (path instanceof RegExp ? path.test(linkPath) : path === linkPath))) {
          eventData.eventCategory = category
          break
        }
      }
    } else if (!/^(.+\.)?sketch\.com$/.test(link.host)) {
      eventData.eventCategory = 'outbound'
    }
  }

  // if (eventData.eventCategory) {
  //   gtag('event', 'click', eventData)
  // }
}

/**
 * Track Google Analytics events
 */
const setUpGoogleAnalytics = function () {
  document.addEventListener('click', (event) => {
    gaCustomEventClickHandler(event)
    // gaLinkClickHandler(event)
  })
}

export default setUpGoogleAnalytics
